var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 20px"}},[_c('treeRender',{attrs:{"list":_vm.treeData,"level":0,"selected":_vm.selected,"call-back":_vm.callBack,"have-extra-button":_vm.haveExtraButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }